export default {
  pageTitle: 'Layanan Retubing',
  metaDescription: 'TEF menyediakan layanan retubing untuk mengganti tube heat exchanger yang aus atau rusak, memulihkan performa termal dan memperpanjang umur peralatan.',
  sidebar: {
    heading: 'Daftar Pemeliharaan dan Rekondisi',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Retubing',
  heading: 'Layanan Retubing dan Penggantian Tube Heat Exchanger',
  paragraph1: 'Kami berspesialisasi dalam retubing dan penggantian tube yang bocor pada heat exchanger, guna memastikan performa optimal dan memperpanjang umur peralatan. Layanan kami dapat dilakukan di workshop kami yang lengkap maupun secara praktis di lokasi Anda, sehingga meminimalkan downtime dan memastikan perbaikan yang efisien.',
  paragraph2: 'Dengan fokus pada presisi dan kualitas, tim berpengalaman kami memastikan proses pelepasan dan pemasangan tube berjalan mulus, mengembalikan heat exchanger Anda ke performa puncaknya. Baik untuk perawatan rutin maupun perbaikan mendesak, kami menyediakan solusi andal yang disesuaikan dengan kebutuhan Anda.',
  steps: {
    step1: 'Pembongkaran Tube',
    step2: 'Pembersihan Tube',
    step3: 'Pelepasan Las',
    step4: 'Penarikan Tube',
    step5: 'Bevel Lubang Tube',
    step6: 'Pengelasan Tube',
  },
};
